if (!customElements.get("swiper-element")) {
	customElements.define(
		"swiper-element",
		class SwiperElement extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				this.swiper = this.querySelector(".swiper");
				if (!this.swiper) return;
				this.options = {
					mousewheel: {
						forceToAxis: true,
					},
				};

				if (this.dataset.autoplay === "true") {
					this.options = {
						autoplay: {
							enabled: true,
							delay: 3000,
							pauseOnMouseEnter: true,
						},
					};
				}

				this.pagination = this.querySelector(".swiper-pagination");
				if (this.pagination) {
					this.options.pagination = {
						el: this.pagination,
						clickable: true,
					};
				}

				this.buttonPrev = this.querySelector(".swiper-button.prev");
				this.buttonNext = this.querySelector(".swiper-button.next");
				if (this.buttonPrev && this.buttonNext) {
					this.options.navigation = {
						prevEl: this.buttonPrev,
						nextEl: this.buttonNext,
					};
				}

				new Swiper(this.swiper, this.options);
			}
		}
	);
}
